module.exports = __webpack_public_path__ + "img/continental-19.7935de8f.jpg";